function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useCallback, useEffect, useMemo, Fragment } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { media } from '../../breakpoints.js';
import { useLogger } from '../../providers/LoggerProvider.js';
import '../Div/index.js';
import '../Image/index.js';
import { Text } from '../Text.js';
import { Lightbox } from './Lightbox.js';
import { isYoutube, standardizeYoutubeUrl, isWistia, isVimeo } from './linkUtils.js';
import { PlayerFrame } from './PlayerFrame.js';
import { Thumbnail } from './Thumbnail.js';
import PlayButtonIcon from '../../../assets/videoPlay-995d36e6.svg';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
import { Image } from '../Image/Image.js';
const i18nKey = 'LazyFacade';
const messages = defineMessages({
  play: {
    id: `${i18nKey}.play`,
    defaultMessage: 'Play',
    description: `#Component: Title
    #CharLimit: 20
    #Context: Play video button text.`
  }
});
function LazyFacade({
  mediaUrl,
  thumbnailUrl,
  thumbnailAlt = '',
  autoplay,
  hasLightbox
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showVideo = _useState2[0],
    setShowVideo = _useState2[1];
  const _useLogger = useLogger(),
    notifyError = _useLogger.notifyError;
  const onPlay = useCallback(() => {
    setShowVideo(true);
  }, []);
  const onClose = useCallback(() => {
    setShowVideo(false);
  }, []);
  useEffect(() => {
    if (autoplay && !hasLightbox) {
      setShowVideo(true);
    }
  }, [autoplay, hasLightbox]);
  const sanitizedUrl = useMemo(() => {
    if (isYoutube(mediaUrl)) return standardizeYoutubeUrl(mediaUrl);
    if (isWistia(mediaUrl) || isVimeo(mediaUrl)) return mediaUrl;
    return;
  }, [mediaUrl]);
  if (!sanitizedUrl) {
    const error = 'Invalid video URL, current only supporting: Youtube, Wistia.';
    notifyError(error);
    throw new Error(error);
  }
  const Container = hasLightbox ? Lightbox : Fragment;
  const lightBoxProps = hasLightbox && {
    close: onClose
  };
  return /*#__PURE__*/jsxs(Facade, {
    onClick: onPlay,
    children: [showVideo && /*#__PURE__*/jsx(Container, _objectSpread(_objectSpread({}, lightBoxProps), {}, {
      children: /*#__PURE__*/jsx(PlayerFrame, {
        mediaUrl: sanitizedUrl,
        autoplay: autoplay
      })
    })), /*#__PURE__*/jsx(Thumbnail, {
      showVideo: showVideo,
      thumbnailAlt: thumbnailAlt,
      thumbnailUrl: thumbnailUrl,
      mediaUrl: sanitizedUrl,
      loading: "eager"
    }), !showVideo && /*#__PURE__*/jsx(FacadePlayOverlay, {})]
  });
}
const OVERLAY_CLASS = 'overlay';
const Facade = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  &:hover,
  &:focus {
    cursor: pointer;

    .${OVERLAY_CLASS} {
      filter: brightness(0.9);
      transition: filter 0.2s cubic-bezier(0, 0, 0.2, 1);
    }
  }
`;
function FacadePlayOverlay() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/jsx(OverlayContainer, {
    className: OVERLAY_CLASS,
    children: /*#__PURE__*/jsxs(OverlayInnerContainer, {
      position: "absolute",
      top: "50%",
      width: "fit-content",
      alignItems: "center",
      right: {
        sm: '50%',
        md: '10%'
      },
      children: [/*#__PURE__*/jsx(Div, {
        height: {
          sm: 64,
          lg: 104
        },
        width: {
          sm: 64,
          lg: 104
        },
        children: /*#__PURE__*/jsx(Image, {
          alt: "Play video",
          src: PlayButtonIcon
        })
      }), /*#__PURE__*/jsx(Text, {
        display: {
          sm: 'none',
          md: 'flex'
        },
        variant: {
          sm: 'display2',
          lg: 'display1'
        },
        spacingStart: {
          sm: 1,
          lg: 3
        },
        as: "p",
        color: "gray0",
        children: formatMessage(messages.play)
      })]
    })
  });
}
const OverlayInnerContainer = styled(Div)`
  transform: translate(50%, -50%);

  ${media.md} {
    transform: translate(0%, -50%);
  }
`;
const OverlayContainer = styled.div`
  pointer-events: none;
  user-select: none;
  height: 100%;
`;
export { LazyFacade };
//# sourceMappingURL=LazyFacade.js.map
